import '@angular/compiler';
import { PortalDizestEditorWorkflowSidebarAppsComponent } from './portal.dizest.editor.workflow.sidebar.apps/portal.dizest.editor.workflow.sidebar.apps.component';
import { PortalGsdcuserApproveSignupComponent } from './portal.gsdcuser.approve.signup/portal.gsdcuser.approve.signup.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalGsdcadminManualStorageComponent } from './portal.gsdcadmin.manual.storage/portal.gsdcadmin.manual.storage.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { ComponentMoveComponent } from './component.move/component.move.component';
import { PortalDizestEditorDefaultComponent } from './portal.dizest.editor.default/portal.dizest.editor.default.component';
import { PortalGsdcuserResearchItemComponent } from './portal.gsdcuser.research.item/portal.gsdcuser.research.item.component';
import { PortalGsdcadminRequestComponent } from './portal.gsdcadmin.request/portal.gsdcadmin.request.component';
import { PageReissueBothComponent } from './page.reissue.both/page.reissue.both.component';
import { PortalGsdcuserWidgetNoticeComponent } from './portal.gsdcuser.widget.notice/portal.gsdcuser.widget.notice.component';
import { PortalGsdcuserFaqItemComponent } from './portal.gsdcuser.faq.item/portal.gsdcuser.faq.item.component';
import { PortalGsdcuserApproveSignupWgroupComponent } from './portal.gsdcuser.approve.signup.wgroup/portal.gsdcuser.approve.signup.wgroup.component';
import { PortalGsdcuserResearchListComponent } from './portal.gsdcuser.research.list/portal.gsdcuser.research.list.component';
import { PortalGsdcuserFaqListComponent } from './portal.gsdcuser.faq.list/portal.gsdcuser.faq.list.component';
import { PortalGsdcuserBoardInfoComponent } from './portal.gsdcuser.board.info/portal.gsdcuser.board.info.component';
import { PortalGsdcadminPasswordComponent } from './portal.gsdcadmin.password/portal.gsdcadmin.password.component';
import { PageStorageComponent } from './page.storage/page.storage.component';
import { PortalGsdcadminBoardListComponent } from './portal.gsdcadmin.board.list/portal.gsdcadmin.board.list.component';
import { PortalGsdcuserNoticeItemComponent } from './portal.gsdcuser.notice.item/portal.gsdcuser.notice.item.component';
import { PortalGsdcadminTicketingListComponent } from './portal.gsdcadmin.ticketing.list/portal.gsdcadmin.ticketing.list.component';
import { PageSupportComponent } from './page.support/page.support.component';
import { PageOtpIssuanceComponent } from './page.otp.issuance/page.otp.issuance.component';
import { PageReissuePasswordComponent } from './page.reissue.password/page.reissue.password.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalDizestEditorSettingComponent } from './portal.dizest.editor.setting/portal.dizest.editor.setting.component';
import { PortalGsdcuserManualComponent } from './portal.gsdcuser.manual/portal.gsdcuser.manual.component';
import { PortalDizestEditorWorkflowSidebarApiComponent } from './portal.dizest.editor.workflow.sidebar.api/portal.dizest.editor.workflow.sidebar.api.component';
import { PortalGsdcuserWidgetUserAddComponent } from './portal.gsdcuser.widget.user.add/portal.gsdcuser.widget.user.add.component';
import { PageNoticeComponent } from './page.notice/page.notice.component';
import { PortalGsdcadminCommunityListComponent } from './portal.gsdcadmin.community.list/portal.gsdcadmin.community.list.component';
import { ComponentPaginationComponent } from './component.pagination/component.pagination.component';
import { PageReissueOtpComponent } from './page.reissue.otp/page.reissue.otp.component';
import { PortalDizestDriveComponent } from './portal.dizest.drive/portal.dizest.drive.component';
import { PortalGsdcuserBoardListComponent } from './portal.gsdcuser.board.list/portal.gsdcuser.board.list.component';
import { PortalGsdcadminCommunityGroupComponent } from './portal.gsdcadmin.community.group/portal.gsdcadmin.community.group.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalGsdcuserApproveGroupNewComponent } from './portal.gsdcuser.approve.group.new/portal.gsdcuser.approve.group.new.component';
import { PortalDizestEditorTerminalComponent } from './portal.dizest.editor.terminal/portal.dizest.editor.terminal.component';
import { PortalGsdcuserTicketingItemComponent } from './portal.gsdcuser.ticketing.item/portal.gsdcuser.ticketing.item.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalGsdcadminTicketingItemComponent } from './portal.gsdcadmin.ticketing.item/portal.gsdcadmin.ticketing.item.component';
import { PortalGsdcuserBoardItemComponent } from './portal.gsdcuser.board.item/portal.gsdcuser.board.item.component';
import { ComponentAlertComponent } from './component.alert/component.alert.component';
import { PageBoardItemComponent } from './page.board.item/page.board.item.component';
import { PortalGsdcuserTicketingListComponent } from './portal.gsdcuser.ticketing.list/portal.gsdcuser.ticketing.list.component';
import { PortalGsdcuserWidgetResearchGraphComponent } from './portal.gsdcuser.widget.research.graph/portal.gsdcuser.widget.research.graph.component';
import { PortalGsdcadminManualListComponent } from './portal.gsdcadmin.manual.list/portal.gsdcadmin.manual.list.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalGsdcadminCommunityItemComponent } from './portal.gsdcadmin.community.item/portal.gsdcadmin.community.item.component';
import { PortalGsdcuserWidgetResearchComponent } from './portal.gsdcuser.widget.research/portal.gsdcuser.widget.research.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalDizestEditorWorkflowSidebarPipComponent } from './portal.dizest.editor.workflow.sidebar.pip/portal.dizest.editor.workflow.sidebar.pip.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PageJoinComponent } from './page.join/page.join.component';
import { PortalDizestEditorHealthComponent } from './portal.dizest.editor.health/portal.dizest.editor.health.component';
import { PageResearchComponent } from './page.research/page.research.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalDizestEditorWorkflowSidebarAiComponent } from './portal.dizest.editor.workflow.sidebar.ai/portal.dizest.editor.workflow.sidebar.ai.component';
import { PortalGsdcuserFaqItemsComponent } from './portal.gsdcuser.faq.items/portal.gsdcuser.faq.items.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalGsdcadminCommunityGroupNewComponent } from './portal.gsdcadmin.community.group.new/portal.gsdcadmin.community.group.new.component';
import { PortalGsdcuserGroupListComponent } from './portal.gsdcuser.group.list/portal.gsdcuser.group.list.component';
import { PortalGsdcuserNoticeListComponent } from './portal.gsdcuser.notice.list/portal.gsdcuser.notice.list.component';
import { PortalDizestEditorWorkflowComponent } from './portal.dizest.editor.workflow/portal.dizest.editor.workflow.component';
import { PortalGsdcadminWidgetUserAddComponent } from './portal.gsdcadmin.widget.user.add/portal.gsdcadmin.widget.user.add.component';
import { PortalGsdcuserStorageComponent } from './portal.gsdcuser.storage/portal.gsdcuser.storage.component';
import { PortalGsdcadminResearchListComponent } from './portal.gsdcadmin.research.list/portal.gsdcadmin.research.list.component';
import { PortalGsdcuserWidgetTicketingComponent } from './portal.gsdcuser.widget.ticketing/portal.gsdcuser.widget.ticketing.component';
import { PortalDizestEditorWorkflowNodeComponent } from './portal.dizest.editor.workflow.node/portal.dizest.editor.workflow.node.component';
import { PortalGsdcadminCommunityUsersComponent } from './portal.gsdcadmin.community.users/portal.gsdcadmin.community.users.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalGsdcuserGroupItemComponent } from './portal.gsdcuser.group.item/portal.gsdcuser.group.item.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalGsdcuserWidgetManualComponent } from './portal.gsdcuser.widget.manual/portal.gsdcuser.widget.manual.component';
import { PortalGsdcadminBoardItemComponent } from './portal.gsdcadmin.board.item/portal.gsdcadmin.board.item.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { PortalGsdcadminFaqListComponent } from './portal.gsdcadmin.faq.list/portal.gsdcadmin.faq.list.component';
import { PageAdminUserComponent } from './page.admin.user/page.admin.user.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalGsdcadminCommunityGroupInfoComponent } from './portal.gsdcadmin.community.group.info/portal.gsdcadmin.community.group.info.component';
import { PortalGsdcuserWidgetBoardComponent } from './portal.gsdcuser.widget.board/portal.gsdcuser.widget.board.component';
import { PageGroupComponent } from './page.group/page.group.component';
import { PageResetPasswordComponent } from './page.reset.password/page.reset.password.component';
import { PortalGsdcadminNoticeItemComponent } from './portal.gsdcadmin.notice.item/portal.gsdcadmin.notice.item.component';
import { PortalGsdcadminUserListComponent } from './portal.gsdcadmin.user.list/portal.gsdcadmin.user.list.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalGsdcuserGroupRequestComponent } from './portal.gsdcuser.group.request/portal.gsdcuser.group.request.component';
import { PortalGsdcadminNoticeListComponent } from './portal.gsdcadmin.notice.list/portal.gsdcadmin.notice.list.component';
import { PortalGsdcuserBoardEditComponent } from './portal.gsdcuser.board.edit/portal.gsdcuser.board.edit.component';
import { PortalDizestEditorWorkflowSidebarInfoComponent } from './portal.dizest.editor.workflow.sidebar.info/portal.dizest.editor.workflow.sidebar.info.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalGsdcadminCommunityNewComponent } from './portal.gsdcadmin.community.new/portal.gsdcadmin.community.new.component';
import { PortalGsdcuserWidgetManualDriveComponent } from './portal.gsdcuser.widget.manual.drive/portal.gsdcuser.widget.manual.drive.component';
import { PortalGsdcuserApproveGroupJoinComponent } from './portal.gsdcuser.approve.group.join/portal.gsdcuser.approve.group.join.component';
import { PortalGsdcadminResearchItemComponent } from './portal.gsdcadmin.research.item/portal.gsdcadmin.research.item.component';
import { ComponentCardComponent } from './component.card/component.card.component';
import { PortalGsdcadminFaqItemComponent } from './portal.gsdcadmin.faq.item/portal.gsdcadmin.faq.item.component';
import { PortalGsdcadminCommunityGroupUserComponent } from './portal.gsdcadmin.community.group.user/portal.gsdcadmin.community.group.user.component';
import { PortalGsdcadminCommunityInfoComponent } from './portal.gsdcadmin.community.info/portal.gsdcadmin.community.info.component';
import { PortalDizestEditorWorkflowSidebarCodeComponent } from './portal.dizest.editor.workflow.sidebar.code/portal.dizest.editor.workflow.sidebar.code.component';
import { PortalGsdcadminWidgetManualDriveComponent } from './portal.gsdcadmin.widget.manual.drive/portal.gsdcadmin.widget.manual.drive.component';
import { PortalDizestEditorImageComponent } from './portal.dizest.editor.image/portal.dizest.editor.image.component';
import { PortalDizestEditorVideoComponent } from './portal.dizest.editor.video/portal.dizest.editor.video.component';
import { ComponentHeaderComponent } from './component.header/component.header.component';
import { PortalGsdcuserTicketingNewComponent } from './portal.gsdcuser.ticketing.new/portal.gsdcuser.ticketing.new.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { MatTreeModule } from '@angular/material/tree';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

@NgModule({
    declarations: [
        AppComponent,
        PortalDizestEditorWorkflowSidebarAppsComponent,
        PortalGsdcuserApproveSignupComponent,
        PortalSeasonLoadingHexaComponent,
        PortalGsdcadminManualStorageComponent,
        PageDashboardComponent,
        ComponentMoveComponent,
        PortalDizestEditorDefaultComponent,
        PortalGsdcuserResearchItemComponent,
        PortalGsdcadminRequestComponent,
        PageReissueBothComponent,
        PortalGsdcuserWidgetNoticeComponent,
        PortalGsdcuserFaqItemComponent,
        PortalGsdcuserApproveSignupWgroupComponent,
        PortalGsdcuserResearchListComponent,
        PortalGsdcuserFaqListComponent,
        PortalGsdcuserBoardInfoComponent,
        PortalGsdcadminPasswordComponent,
        PageStorageComponent,
        PortalGsdcadminBoardListComponent,
        PortalGsdcuserNoticeItemComponent,
        PortalGsdcadminTicketingListComponent,
        PageSupportComponent,
        PageOtpIssuanceComponent,
        PageReissuePasswordComponent,
        PortalSeasonAlertComponent,
        PortalDizestEditorSettingComponent,
        PortalGsdcuserManualComponent,
        PortalDizestEditorWorkflowSidebarApiComponent,
        PortalGsdcuserWidgetUserAddComponent,
        PageNoticeComponent,
        PortalGsdcadminCommunityListComponent,
        ComponentPaginationComponent,
        PageReissueOtpComponent,
        PortalDizestDriveComponent,
        PortalGsdcuserBoardListComponent,
        PortalGsdcadminCommunityGroupComponent,
        PortalSeasonUiDropdownComponent,
        PortalGsdcuserApproveGroupNewComponent,
        PortalDizestEditorTerminalComponent,
        PortalGsdcuserTicketingItemComponent,
        PortalSeasonLoadingComponent,
        PortalGsdcadminTicketingItemComponent,
        PortalGsdcuserBoardItemComponent,
        ComponentAlertComponent,
        PageBoardItemComponent,
        PortalGsdcuserTicketingListComponent,
        PortalGsdcuserWidgetResearchGraphComponent,
        PortalGsdcadminManualListComponent,
        PortalSeasonStatusbarComponent,
        PortalGsdcadminCommunityItemComponent,
        PortalGsdcuserWidgetResearchComponent,
        LayoutEmptyComponent,
        PortalDizestEditorWorkflowSidebarPipComponent,
        ComponentNavAdminComponent,
        PageJoinComponent,
        PortalDizestEditorHealthComponent,
        PageResearchComponent,
        PageLoginComponent,
        PortalDizestEditorWorkflowSidebarAiComponent,
        PortalGsdcuserFaqItemsComponent,
        PortalSeasonTabComponent,
        PortalGsdcadminCommunityGroupNewComponent,
        PortalGsdcuserGroupListComponent,
        PortalGsdcuserNoticeListComponent,
        PortalDizestEditorWorkflowComponent,
        PortalGsdcadminWidgetUserAddComponent,
        PortalGsdcuserStorageComponent,
        PortalGsdcadminResearchListComponent,
        PortalGsdcuserWidgetTicketingComponent,
        PortalDizestEditorWorkflowNodeComponent,
        PortalGsdcadminCommunityUsersComponent,
        PageAdminComponent,
        PortalGsdcuserGroupItemComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalGsdcuserWidgetManualComponent,
        PortalGsdcadminBoardItemComponent,
        LayoutUserComponent,
        PortalGsdcadminFaqListComponent,
        PageAdminUserComponent,
        LayoutAdminComponent,
        ComponentNavUserComponent,
        PageMypageComponent,
        PortalGsdcadminCommunityGroupInfoComponent,
        PortalGsdcuserWidgetBoardComponent,
        PageGroupComponent,
        PageResetPasswordComponent,
        PortalGsdcadminNoticeItemComponent,
        PortalGsdcadminUserListComponent,
        PortalSeasonViewerTreeComponent,
        PortalGsdcuserGroupRequestComponent,
        PortalGsdcadminNoticeListComponent,
        PortalGsdcuserBoardEditComponent,
        PortalDizestEditorWorkflowSidebarInfoComponent,
        PortalSeasonPagenationComponent,
        PortalGsdcadminCommunityNewComponent,
        PortalGsdcuserWidgetManualDriveComponent,
        PortalGsdcuserApproveGroupJoinComponent,
        PortalGsdcadminResearchItemComponent,
        ComponentCardComponent,
        PortalGsdcadminFaqItemComponent,
        PortalGsdcadminCommunityGroupUserComponent,
        PortalGsdcadminCommunityInfoComponent,
        PortalDizestEditorWorkflowSidebarCodeComponent,
        PortalGsdcadminWidgetManualDriveComponent,
        PortalDizestEditorImageComponent,
        PortalDizestEditorVideoComponent,
        ComponentHeaderComponent,
        PortalGsdcuserTicketingNewComponent,
        LayoutNavbarComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
                MatTreeModule
    ],
    providers: [{
        provide: COMPOSITION_BUFFER_MODE,
        useValue: false
    }],
    bootstrap: [AppComponent]
})
export class AppModule { }